export default {
    share_label_1: 'Tell your friends',
    share_label_2: 'Not To F* This Up!',
    donate_label: 'Donate',
};
